module.exports = __webpack_public_path__ + "static/media/spring-boot-logo.d1fe8d0f.jpg";